import * as types from '../const/action.types';

export function sessionReducer(
    state = { user: undefined, token: undefined, valid: undefined, info: undefined },
    action,
) {
    switch (action.type) {
        case types.LOG_IN_SUCCESS:
            console.log(action.token);
            sessionStorage.setItem('user', action.user);
            sessionStorage.setItem('token', action.token);
            return {
                user: action.user,
                token: action.token,
                valid: action.valid,
                info: state.info,
            };
        case types.KEEP_SESSION:
            console.log(`Keep session ${action.time}`);
            return {
                user: state.user,
                token: state.token,
                valid: action.time,
                info: state.info,
            };
        case types.LOAD_SESSION_USER_SUCCESS:
            return {
                user: state.user,
                token: state.token,
                valid: state.valid,
                info: action.data,
            };
        case types.LOG_OUT:
            console.log('LOG  OUT');
            sessionStorage.setItem('user', undefined);
            sessionStorage.setItem('token', undefined);
            return {
                user: undefined,
                token: undefined,
                valid: undefined,
                locales: state.locales,
            };
        default:
            return state;
    }
}

export function basicInfo(state = {}, action) {
    switch (action.type) {
        case types.LOAD_BASIC_INFO_SECURITY:
            return {
                security: action.data,
            };
        default:
            return state;
    }
}

export function sessionUsersHasErrored(state = { hasErrored: false, error: '' }, action) {
    switch (action.type) {
        case types.SESSION_USER_HAS_ERROR:
            return {
                hasErrored: action.hasErrored,
                error: action.error,
            };

        default:
            return state;
    }
}

export function sessionUsersIsLoading(state = false, action) {
    switch (action.type) {
        case types.SESSION_USER_IS_LOADING:
            return action.isLoading;
        default:
            return state;
    }
}

export function tutorial(state = false, action) {
    switch (action.type) {
        case types.TUTORIAL:
            return action.show;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/session.reducer.js